import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { router } from './app/router';
import { initI18n } from './lib/i18n';
import { createQueryClient } from './lib/query';
import { ElevationProvider } from './lib/elevation';
import './styles/tokens.css';
import './styles/components.css';

async function bootstrap(): Promise<void> {
  // i18n 必须在首次渲染前就绪，否则会闪过一帧未翻译的 key
  await initI18n();

  const container = document.getElementById('root');
  if (!container) throw new Error('#root not found');

  createRoot(container).render(
    <StrictMode>
      <QueryClientProvider client={createQueryClient()}>
        <ElevationProvider>
          <RouterProvider router={router} />
        </ElevationProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
}

void bootstrap();

// PWA 就绪（M11）：只在生产构建里注册——开发环境用 Vite dev server 走
// HMR，服务工作线程的静态资源缓存会跟 HMR 打架（缓存住旧模块、看不出改动）。
// public/sw.js 只做应用外壳缓存，绝不缓存 /api/*，绝不支持离线写，见该文件
// 顶部注释。
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js');
  });
}
